import React from "react";

interface SuccessModalProps {
    show: boolean;
    onClose: () => void;
    message: string;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ show, onClose, message }) => {
    if (!show) return null;

    return (
        <div className="modal fade show" style={{ display: "block" }} tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-dialog-centered" style={{ zIndex: 1051 }} >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Success</h5>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close" />
                    </div>
                    <div className="modal-body">
                        <p className="text-success">{message}</p>
                    </div>
                    <div className="modal-footer">
                        <button onClick={onClose} className="btn btn-success">
                            OK
                        </button>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" />
        </div>
    );
};
export default SuccessModal;